module.exports = __webpack_public_path__ + "img/mind_element_more1.a7f94bec.png";